import { ArtworkBoxSoldSummary, Dropdown, Pagination, StyledComponent } from '@on-arte/ui';
import styled from 'styled-components';

export const StyledArtworkBoxSoldSummary: StyledComponent<typeof ArtworkBoxSoldSummary> = styled(ArtworkBoxSoldSummary)`
  & + & {
    margin-top: 20px;
  }
`;

export const StyledPagination: StyledComponent<typeof Pagination> = styled(Pagination)`
  margin-top: 20px;
`;

export const StyledDropdown: StyledComponent<typeof Dropdown> = styled(Dropdown)`
  width: 200px;
  margin-bottom: 24px;
`;
